import { Box, Toolbar, Card } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { MenuBar } from '../MenuBar';

export interface HeapLiveViewProps {
  actionBarContent: ReactNode;
  captureCardContent: ReactNode;
}

export function HeapLiveView({ actionBarContent, captureCardContent }: HeapLiveViewProps): ReactElement {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100dvh',
        boxSizing: 'border-box',
      }}
    >
      <MenuBar />
      <Toolbar /> {/* Spacer for fixed AppBar */}
      <Box sx={{ padding: 1, flex: 1, overflow: 'auto', boxSizing: 'border-box' }}>
        <Box
          sx={{
            maxWidth: '90%',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            height: '100%',
          }}
        >
          <Card
            sx={{
              padding: 2,
              width: '100%',
              borderRadius: 3,
              border: '1px solid',
              borderColor: 'divider',
              boxShadow: '0 18px 36px rgba(15,23,42,0.10)',
              boxSizing: 'border-box',
            }}
          >
            {actionBarContent}
          </Card>
          <Card
            sx={{
              width: '100%',
              height: 'calc(100% - 64px)',
              borderRadius: 3,
              border: '1px solid',
              borderColor: 'divider',
              boxSizing: 'border-box',
              boxShadow: '0 18px 36px rgba(15,23,42,0.10)',
              textAlign: 'center',
              margin: '0 auto',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {captureCardContent}
          </Card>
        </Box>
      </Box>
    </Box>
  );
}
